import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'glxy-nav-panel',
    templateUrl: './nav-panel.component.html',
    styleUrls: ['./nav-panel.component.scss']
})
export class NavPanelComponent implements OnInit {
    @Input() isAdmin = false;
    @Input() set isPlatformUser(isPlatformUser: boolean) {
        if (isPlatformUser) {
            this.adminLinks = this.adminLinks.filter(
                (link) => link.state !== 'org.billing' && link.state !== 'org.apps.list'
            );
        }
    }
    @Input() orgName = 'Admin';

    public navLinks = [
        {
            name: 'Meetings',
            state: 'meetings',
            items: [
                {
                    state: 'tasks.wizard',
                    name: 'Schedule',
                    params: {
                        wizardSkill: 'meeting-create',
                        taskId: null,
                        meetingType: null
                    }
                },
                {
                    state: 'settings.meeting',
                    name: 'Settings'
                },
                {
                    state: 'tasks.active',
                    name: 'Tasks'
                },
                {
                    state: 'calendar',
                    name: 'Calendar'
                },
                {
                    name: 'Contacts',
                    icon: 'users',
                    state: 'contacts.list'
                }
            ]
        },
        {
            state: 'settings.accounts.add',
            name: 'Integrations',
            items: [
                {
                    name: 'My Integrations',
                    state: 'settings.accounts.list'
                },
                {
                    name: 'Unified Search',
                    state: 'search'
                }
            ]
        }
    ];
    public adminLinks = [
        {
            name: this.orgName,
            state: 'org.settings',
            items: [
                {
                    state: 'org.settings',
                    name: 'Settings'
                },
                {
                    state: 'org.users',
                    name: 'Users'
                },
                {
                    state: 'org.accounts.list',
                    name: 'Integrations'
                },
                {
                    state: 'org.apps.list',
                    name: 'Applications'
                },
                {
                    state: 'org.billing',
                    name: 'Billing'
                },
                {
                    state: 'org.report',
                    name: 'Reports'
                },
                {
                    state: 'org.events',
                    name: 'History'
                }
            ]
        }
    ];

    constructor() {}

    ngOnInit() {}
}
